import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useToast } from '../../contexts/ToastContext';
import { platformFetch } from '../../utils/platformApi';
import API_BASE from '../../config';
import LordIcon from '../LordIcon';
import LORDICONS from '../../lordicons';

const ImpersonationBanner: React.FC = () => {
  const { user, setUser } = useAuth();
  const { t } = useLanguage();
  const toast = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  if (!user?.impersonating) return null;

  const handleExit = async () => {
    setLoading(true);
    try {
      await platformFetch('/impersonation/exit', { method: 'POST', body: '{}' });
      const meRes = await fetch(`${API_BASE}/api/users/me`, { credentials: 'include' });
      const me = await meRes.json();
      if (!meRes.ok) throw new Error(me.error || 'Failed to restore admin session');
      localStorage.setItem('user', JSON.stringify(me));
      setUser(me);
      window.dispatchEvent(new Event('userUpdated'));
      toast.success(t('admin.impersonation.ended'));
      navigate('/admin', { replace: true });
    } catch (err: any) {
      toast.error(err?.message || t('admin.error.generic'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2.5 flex items-center justify-between gap-4 shadow-md">
      <div className="flex items-center gap-2 text-sm font-medium min-w-0">
        <LordIcon src={LORDICONS.eye} trigger="loop" size={20} color="#ffffff" />
        <span className="truncate">
          {t('admin.impersonation.banner', {
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
          })}
        </span>
      </div>
      <button
        type="button"
        onClick={handleExit}
        disabled={loading}
        className="flex-shrink-0 px-3 py-1.5 rounded-lg bg-white text-amber-800 text-sm font-semibold hover:bg-amber-50 disabled:opacity-60"
      >
        {loading ? t('admin.working') : t('admin.impersonation.exit')}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
